import { useContext, useEffect } from 'react'

import { authService } from 'auth'
import { AuthProviderContext } from 'containers/auth'
import { useDispatch } from 'store'
import { actions } from 'store/users'

export const UserProfileProvider = ({
  children,
}: {
  children: React.ReactElement
}): React.ReactElement => {
  const dispatch = useDispatch()
  const { isAuthReady } = useContext(AuthProviderContext)
  useEffect(() => {
    const getUserProfile = async () => {
      const isUserLoggedIn = await authService.isAuthenticated()

      if (!isUserLoggedIn) {
        return
      }
      await dispatch(actions.getUserProfile())
    }

    if (isAuthReady) {
      // eslint-disable-next-line no-void
      void getUserProfile()
    }
  }, [dispatch, isAuthReady])

  return children
}
